import { render, staticRenderFns } from "./EditTournament.vue?vue&type=template&id=9f8429c2&scoped=true"
import script from "./EditTournament.vue?vue&type=script&lang=js"
export * from "./EditTournament.vue?vue&type=script&lang=js"
import style0 from "./EditTournament.vue?vue&type=style&index=0&id=9f8429c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8429c2",
  null
  
)

export default component.exports